import axiosClient from '../axiosClient';
import { ENTITY_COMPONENTS_API_URL } from '../constants';

const ComponentEntity = {
  createComponent: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ENTITY_COMPONENTS_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  createComponentWithUpload: async (body: any) => {
    try {
      //Add formData
      const response = await axiosClient.post(`${ENTITY_COMPONENTS_API_URL}/upload`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchComponents: async (params: any) => {
    try {
      const response = await axiosClient.get(ENTITY_COMPONENTS_API_URL, { params });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  deleteComponent: async (params: any) => {
    try {
      const response = await axiosClient.delete(ENTITY_COMPONENTS_API_URL, { params });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },

  uploadComponents: async (body: FormData) => {
    try {
      const response = await axiosClient.post(`${ENTITY_COMPONENTS_API_URL}/upload`, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },

  updateComponentDetails: async (body: any) => {
    try {
      const response = await axiosClient.put(`${ENTITY_COMPONENTS_API_URL}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
};

export default ComponentEntity;
